module.exports = __webpack_public_path__ + "static/media/airplane-shape.8a01f7a0.svg";